import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  startDate?: string;
  endDate?: string;
  year?: string;
}

export const useGenerateCBAMReport = () => {
  return useMutation({
    mutationFn: async ({ startDate, endDate, year }: HookProps) => {
      await request(
        {
          path: `batches/generate-cbam-report`,
          method: 'POST',
          authenticate: true,
          dataObject: { startDate, endDate, year },
        },
        true,
      );
    },
    onSuccess: () => {
      toast.success('The CBAM report is being generated.');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the CBAM report!');
    },
  });
};
